module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fc-Gb-Hc-Ib-Ja.73f8c073.png";